import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import { injectGlobal, prefix } from "../../../../lib/theming/Emotion";
export var globalClasses = prefix('colorable')({
  input: 'input'
});
injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  input.", " {\n    display: inline-block;\n    background-color: transparent;\n    background-size: 100%;\n    background-repeat: repeat;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n"])), globalClasses.input);